import { useState } from 'react';
import type { OpensipsReloadResult } from '../../../services/opensips.types';
import { AlertService } from '../../../services/alert.service';
import Icon from '../../../components/forms/icon.component';

/**
 * Fuerza un reload MI en OpenSIPS (lb_reload / address_reload / dp_reload). El backend ya lo
 * dispara tras cada escritura; este botón es para cuando alguien tocó la BD a mano o el reload
 * automático falló.
 */
export default function OpensipsReloadButton({
  label,
  command,
  onReload
}: {
  label: string;
  /** nombre del comando MI, solo informativo */
  command: string;
  onReload: () => Promise<OpensipsReloadResult>;
}) {
  const [busy, setBusy] = useState(false);

  const click = async () => {
    const ok = await AlertService.question(
      label,
      `Se ejecutará \`${command}\` en OpenSIPS (137.184.186.26) vía MI. No corta llamadas en curso, pero recarga la tabla completa desde MySQL.`,
      () => Promise.resolve(true),
      'Recargar'
    );
    if (!ok) return;
    try {
      setBusy(true);
      const res = await onReload();
      if (res?.ok) AlertService.toastSuccess(`${command}: ${res.message || 'OK'}`);
      else AlertService.toastError(`${command} falló: ${res?.message || 'sin detalle'}`);
    } catch (error: any) {
      AlertService.toastError(error?.error || `No se pudo ejecutar ${command}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className="btn btn-light-warning d-flex align-items-center gap-2 hover-scale fs-7 fw-bold rounded-pill"
      onClick={click}
      disabled={busy}
      title={command}
    >
      <Icon icon="ki-arrows-circle" size="fs-3" />
      {busy ? 'Recargando…' : label}
    </button>
  );
}
